
  <template>
    <div class="container-fluid p-0 m-0" >
      <div class="row p-0 m-0">
        <div class="col-12 p-0 m-0">
          <div class="input-group">
            <span class="input-group-prepend">
              <span class="input-group-text"><i class="icon-calendar22"></i></span>
            </span>
            <input type="text" v-bind:id="'calender' + getId()" class="form-control" value="01/01/2015 - 01/31/2015">
          </div>
        </div>
      </div>
      <div class="row p-0 m-0">
        <div class="col-12 p-0 m-0" v-bind:id="'datedrop' + getId()">
         <div class="content-inner"></div>
        </div>
      </div>
    </div>
  </template>

<script>

  import moment from 'moment'

	export default {
    name: 'input-inline-daterange',
		components: {
    },
    props: {
      onchangeddatefunction: {
        required: false,
        type: String,
        default: null
      },
      drops: {
        required: false,
        type: String,
        default: 'down'
      },
      
    },
    methods: {
      getId() {
        return this._uid;
      },
      daterangeChanged(start, end, label) {
        
        var copystart = JSON.parse(JSON.stringify(start))
        var copyend = JSON.parse(JSON.stringify(end))
        this.$emit('changed', copystart, copyend);
        if (this.onchangeddatefunction != null) {
          eval(this.onchangeddatefunction + "(copystart,copyend)")
        }
      },
      clearDates() {
        $('#calender' + this.getId()).data('daterangepicker').setStartDate(moment().format("MM-DD-YYYY")); //date now
        $('#calender' + this.getId()).data('daterangepicker').setEndDate(moment().format("MM-DD-YYYY"));//date now
      },
      setDateRange(start, end) {
        $('#calender' + this.getId()).data('daterangepicker').setStartDate(start);
        $('#calender' + this.getId()).data('daterangepicker').setEndDate(end);
      },
      initCalender(date) {
        var locale = $.datepicker.regional[this.$store.getLocale()];

        var settings = {
          startDate: moment().subtract(29, 'days'),
          endDate: moment(),
          dateLimit: { days: 60 },
          parentEl: '#datedrop' + this._uid + ' .content-inner',
          width: 'fit-content',
          ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
          },
          orientation: "auto",
          parentEl: '.content-inner',
          locale: locale,
          onSelect: function () {

            //$(this).change();
           
          },
          onChangeMonthYear: function () {
            //alert('o');
          },
          drops: this.drops
        };
        var thisContext = this;
        $('#calender' + this.getId()).daterangepicker(settings, function (start, end, label) {
          
          thisContext.daterangeChanged(start, end, label)

        } );

        //$('#calender' + this.getId()).on('apply.daterangepicker', function (ev, picker) {
          //alert();
        //});
      }
      
    },
    data() {
      return {
      }
    },
    created() {
      
    },
    mounted() {
      this.initCalender(new Date());
    },
    computed: {
      
    },
    watch: {
      
    }
}
</script>

<style scoped>
  
</style>

<style>
  .daterangepicker {
    position: relative !important;
    left:0px;
  }
  .content-inner{

  }
</style>



// WEBPACK FOOTER //
// src/components/form-components/input-inline-daterange.vue